// zustand/store/useCardStore.ts
import { create } from "zustand";
import { CardFormValues } from "@/types/Card";

interface CardState {
  allCards: CardFormValues[];
  bookmarkedIds: string[];
  isLoading: boolean;
  hasFetched: boolean;
  setCards: (cards: CardFormValues[]) => void;
  setBookmarked: (ids: string[]) => void;
  setLoading: (loading: boolean) => void;
  setHasFetched: (hasFetched: boolean) => void;
  deckIds: string[];
  setMyDeck: (ids: string[]) => void;
}

export const useCardStore = create<CardState>((set) => ({
  allCards: [],
  bookmarkedIds: [],
  isLoading: true,
  hasFetched: false,
  deckIds: [],
  setMyDeck: (ids) => set({ deckIds: ids }),
  setCards: (cards) => set({ allCards: cards }),
  setBookmarked: (ids) => set({ bookmarkedIds: ids }),
  setLoading: (loading) => set({ isLoading: loading }),
  setHasFetched: (hasFetched) => set({ hasFetched }),
}));
